export default __webpack_public_path__ + "static/media/logo-CMH.5a0fa477.svg";